import { makeStyles } from '@material-ui/core';

import { IsolvedLogoIcon } from '../../icons/IsolvedLogoIcon';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <IsolvedLogoIcon classes={{ svg: classes.svg }} />;
};

export default LogoIcon;
